<script setup lang="ts">
import LayoutSwitch from '@/components/layouts/LayoutSwitch.vue';
import { useMaintenanceModeSignalR } from '@/components/maintenanceMode/useMaintenanceModeSignalR';

useMaintenanceModeSignalR();
</script>

<template>
  <LayoutSwitch>
    <RouterView />
  </LayoutSwitch>
</template>
